import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { FeesSection, CorrespondentOnlySection, DynamicFee } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface LenderCreditsFeesFormData {
  interestRateCredit: number;
  fundingFee: number;
  wireFee: number;
  dynamicFees: DynamicFee[];
}

@Component({
  selector: 'lender-credits-fees',
  templateUrl: './lender-credits-fees.component.html',
  styleUrls: ['./lender-credits-fees.component.scss'],
  standalone: false
})
export class LenderCreditsFeesComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('lenderCreditsFeesForm') lenderCreditsFeesForm: NgForm;

  @Input() fees: FeesSection | undefined;
  @Input() correspondentOnly: CorrespondentOnlySection | undefined;

  formData: LenderCreditsFeesFormData = {
    interestRateCredit: null,
    fundingFee: null,
    wireFee: null,
    dynamicFees: []
  };

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fees'] || changes['correspondentOnly']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.lenderCreditsFeesForm) {
      this.lenderCreditsFeesForm.form.markAllAsTouched();
      return this.lenderCreditsFeesForm.form.valid;
    }
    return true;
  }

  getFormData(): LenderCreditsFeesFormData {
    return {
      ...this.formData,
      dynamicFees: [...this.formData.dynamicFees]
    };
  }

  addDynamicFee(): void {
    this.formData.dynamicFees.push({ uuid: crypto.randomUUID(), name: '', amount: null });
  }

  removeDynamicFee(index: number): void {
    this.formData.dynamicFees.splice(index, 1);
  }

  private populateFormFromApiData(): void {
    if (this.fees) {
      this.formData.interestRateCredit = this.fees.interestRateCredit || null;
      this.formData.wireFee = this.fees.wireFee || null;

      this.formData.dynamicFees = this.fees.dynamicOtherFees?.map(fee => ({
        ...fee,
        uuid: fee.uuid || crypto.randomUUID()
      })) || [];
    }
  }
}
